/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { AddressSection } from "./AddressSection";
import { CardView } from "./CardView";
import { ProfileSection } from "./ProfileSection";
import { React } from "react";

const AccountAndSettings = () => {
  return (
    <>
      <ProfileSection />
      <AddressSection />
      <CardView />
    </>
  );
};

export {AccountAndSettings};
